module.exports = __webpack_public_path__ + "static/media/play_black.18b79b64.svg";